import React from "react";
import { Header } from "./Header";
import { GeoRestrictionProvider } from "../../contexts/GeoRestrictionContext";
import BackgroundImage from "../../assets/KYCBG.png";
// import { Footer } from "./Footer";

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <GeoRestrictionProvider>
      <div
        className="min-h-screen bg-gradient-to-b from-zinc-50 to-zinc-100"
        style={{ backgroundImage: `url(${BackgroundImage})` }}
      >
        <Header />
        <main className="container mx-auto px-0 sm:px-6 lg:px-8 py-0 sm:py-8">
          {children}
        </main>
        {/* <Footer /> */}
      </div>
    </GeoRestrictionProvider>
  );
}
